import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { Bulletin_Search, TableSchema } from '../model/bulletin';
import { ReturnClass } from 'projects/Shared-Lib/model/search-result';
import * as t from '../lib/select/select-service';
import { AppService } from '../services/app.service';
import { FilterDataService } from '../services/filter-data.service';
import { Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { TableSetting } from 'projects/Shared-Lib/component/table/table-class';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.css']
})
export class BulletinComponent implements OnInit {
  @ViewChild('acc') acc: NgbAccordionItem; //link to ngAfterViewInit().
  searchFilter: Bulletin_Search;
  DropdownEnabled = t.GetItems(t.Items.Options_Enabled, false, { value: 2, text: 'All the below', index: 0 }).slice(0);
  //傳入 DataTable 資料之變數
  TableData: ReturnClass;
  currentRoute: string;
  controllerName = 'Bulletin';
  userPermission: any;
  TableSetting: TableSetting;

  constructor(private httpSer: DataService,
    private appService: AppService,
    private filterService: FilterDataService,
    private router: Router,
    private DlgService: DialogService) {

    this.searchFilter = new Bulletin_Search();
    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'BulletinId';
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'EffectiveDate', header: 'Effective Date', cell: (element: TableSchema) => `${element.EffectiveDate.ToDateString()}` },
      { columnDef: 'ExpiredDate', header: 'Expired Date', cell: (element: TableSchema) => `${element.ExpiredDate.ToDateString()}` },
      { columnDef: 'Subject', header: 'Subject' },
      { columnDef: 'IsEnabled', header: 'IsEnabled', cell: (element: TableSchema) => `${element.IsEnabled == 'True' ? "Y" : "N"}` },
      { columnDef: 'UpdatedBy', header: 'Update User' },
      { columnDef: 'UpdatedDateTime', header: 'Update Date', cell: (element: TableSchema) => `${element.UpdatedDateTime.ToDateTimeString()}` },
    ];

    this.userPermission = this.appService.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = data.CanUpdate;
      this.TableSetting.CanDelete = data.CanDelete;
    })

  }

  ngOnInit() {
    setTimeout(() => this.appService.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  ngAfterViewInit() {
    // The ngb-accordion object can only be accessed after the page has initialized: setTimeout(() => this.acc.expandAll(), 0);
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.searchFilter.filter = LasttimeSearchInfo.Filter;
      }
    }

    if (this.searchFilter.filter.EffectiveDate === null) {
      this.searchFilter.filter.EffectiveDate = '';
    }

    this.filterService.ChangeSearchInfo(this.currentRoute, this.searchFilter.filter);

    console.log('searchFilter.filter', this.searchFilter.filter);
    this.httpSer.getData(this.controllerName + '/List', this.searchFilter.filter,
      (data) => {
        this.TableData = {
          draw: this.searchFilter.filter.PageIndex,
          pagingSize: this.searchFilter.filter.PageSize,
          recordsTotal: data.TotalCount,
          recordsFiltered: data.TotalCount,
          data: data.DataList
        };
        setTimeout(() => this.appService.SetLoadingState(false), 0);
      });
  }

  onChangePageInfo(PageInfo: any) {
    this.searchFilter.filter.PageSize = PageInfo.PageSize;
    this.searchFilter.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }

  onChangeTableInfo(TableInfo: any) {
    this.searchFilter.filter.SortBy = TableInfo.SortBy;
    this.searchFilter.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }

  Delete(DeleteItem) {
    console.log('delete id', DeleteItem)
    this.appService.SetLoadingState(true);
    this.httpSer.DeleteData(`${this.controllerName}/${DeleteItem.BulletinId}`, null,
      (res) => {
        console.log(res);
        this.Search();
      },
      (res) => {
        let result = this.DlgService.ErrorInformation(res.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.appService.SetLoadingState(false);
      }
    );
  }
}
